module.exports = __webpack_public_path__ + "img/Icon-Add Text Fields on document.7f60dc1c.svg";